<template>

  <section class="o-section">
    <div class="o-section__wrapper is-bottom-left" ref="wrapper">

      <div class="o-wrapper e-page--afterword-wrapper" v-if="active">
        <div class="u-8/12@desktop u-push-2/12@desktop u-6/12@wide u-push-3/12@wide e-page--afterword">
          <h1>{{ afterword.title }}</h1>
          <div v-html="afterword.text"></div>

          <div class="u-align-center e-page--afterword-bottom">
            <img src="/assets/signature.png" alt="Signature Bart Verhaege"> <br>
            <strong>Bart Verhaeghe</strong> <br>
            {{ afterword.subword }}
          </div>
        </div>
      </div>

      <div class="o-section__figure-wrapper" v-if="isDesktop">
        <figure class="o-section__figure" ref="figureE">
          <Img :src="require('@/assets/intro/intro_e.png')" filename="intro_e" />
        </figure>

        <figure class="o-section__figure" ref="figureB">
          <Img :src="require('@/assets/intro/intro_b.png')" filename="intro_b" />
        </figure>

        <figure class="o-section__figure" ref="figureC">
          <Img :src="require('@/assets/intro/intro_c.png')" filename="intro_c" />
        </figure>
      </div>
    </div>
  </section>

</template>

<script>
import { mapState } from 'vuex'
import Img from '@/components/Img'

export default {
  name: 'Scene13',
  props: ['options', 'active', 'copy', 'disableBlur', 'isDesktop'],

  mounted () {
    this.$root.$on('startScene13', () => {
      this.init()
    })
  },

  methods: {
    init () {
      this.$anime({
        targets: [this.$refs.figureB, this.$refs.figureC, this.$refs.figureE],
        opacity: [0, 1],
        duration: this.options.durationSmall,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureB,
        translateX: ['-20px', '0'],
        duration: this.options.durationRegular,
        easing: this.options.easing
      })

      this.$anime({
        targets: this.$refs.figureC,
        translateX: ['40px', '0'],
        duration: this.options.durationRegular,
        easing: this.options.easing
      })

      if (this.disableBlur) {
        this.$anime({
          targets: this.$refs.figureE,
          translateX: ['-40px', '0'],
          opacity: [0, 1],
          delay: 200,
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      } else {
        this.$anime({
          targets: this.$refs.figureE,
          translateX: ['-40px', '0'],
          filter: ['blur(5px)', 'blur(0px)'],
          duration: this.options.durationLarge,
          easing: this.options.easing
        })
      }
    }
  },

  computed: mapState({
    lang: state => state.language,
    afterword (state) {
      const lang = this.lang
      return state.translations.afterword[lang]
    }
  }),

  components: {
    Img
  }
}
</script>
